// Everything that's not exported was something that's not currently in use, but would be a pain to regenerate
// I THINK it will be tree shook out of the build without adding bloat

// As of Jan 2019

// Per these docs, https://github.com/yahoo/react-intl/wiki/Components#formattednumber react intl uses Intl.NumberFormat https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat , which relies on the ISO 4217 currency codes
// Classpass internally uses the https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3 standard for country codes.

// I created this map of country codes to currency codes from the data here https://datahub.io/core/country-codes#data (json format)

// some countries have null currencies; I believe these are countries that lack an official currency. React intl will likely error if you give it null for a currency type, which will hopefully lead you here, where you can figure out how to address that problem.
// The original dataset had a couple countries with null currency codes that OTHER datasets said do have valid codes, like Taiwan. I filled in these gaps with https://www.currency-iso.org/dam/downloads/lists/list_one.xml and left comments denoting which codes were filled in by hand from the second dataset.
// Other countries have multiple currencies; I just picked the one that comes first in the original dataset as a default and left the other one as a comment.

// I manually checked the codes for all the countries where classpass operates and I'm fairly confident in the automatic parsing, but if you get incorrect currencies, it might be worth making sure everything here is correct/up to date.

export const countryCodeToCurrencyCode = {
  TWN: 'TWD', // null in first dataset
  AFG: 'AFN',
  ALB: 'ALL',
  DZA: 'DZD',
  ASM: 'USD',
  AND: 'EUR',
  AGO: 'AOA',
  AIA: 'XCD',
  ATA: null,
  ATG: 'XCD',
  ARG: 'ARS',
  ARM: 'AMD',
  ABW: 'AWG',
  AUS: 'AUD',
  AUT: 'EUR',
  AZE: 'AZN',
  BHS: 'BSD',
  BHR: 'BHD',
  BGD: 'BDT',
  BRB: 'BBD',
  BLR: 'BYN',
  BEL: 'EUR',
  BLZ: 'BZD',
  BEN: 'XOF',
  BMU: 'BMD',
  BTN: 'INR', // ,BTN',
  BOL: 'BOB',
  BES: 'USD',
  BIH: 'BAM',
  BWA: 'BWP',
  BVT: 'NOK',
  BRA: 'BRL',
  IOT: 'USD',
  VGB: 'USD',
  BRN: 'BND',
  BGR: 'BGN',
  BFA: 'XOF',
  BDI: 'BIF',
  CPV: 'CVE',
  KHM: 'KHR',
  CMR: 'XAF',
  CAN: 'CAD',
  CYM: 'KYD',
  CAF: 'XAF',
  TCD: 'XAF',
  CHL: 'CLP',
  CHN: 'CNY',
  HKG: 'HKD',
  MAC: 'MOP',
  CXR: 'AUD',
  CCK: 'AUD',
  COL: 'COP',
  COM: 'KMF',
  COG: 'XAF',
  COK: 'NZD',
  CRI: 'CRC',
  HRV: 'HRK',
  CUB: 'CUP', // ,CUC',
  CUW: 'ANG',
  CYP: 'EUR',
  CZE: 'CZK',
  CIV: 'XOF',
  PRK: 'KPW',
  COD: 'CDF',
  DNK: 'DKK',
  DJI: 'DJF',
  DMA: 'XCD',
  DOM: 'DOP',
  ECU: 'USD',
  EGY: 'EGP',
  SLV: 'SVC', // ,USD',
  GNQ: 'XAF',
  ERI: 'ERN',
  EST: 'EUR',
  ETH: 'ETB',
  FLK: 'FKP', // null in first dataset
  FRO: 'DKK',
  FJI: 'FJD',
  FIN: 'EUR',
  FRA: 'EUR',
  GUF: 'EUR',
  PYF: 'XPF',
  ATF: 'EUR',
  GAB: 'XAF',
  GMB: 'GMD',
  GEO: 'GEL',
  DEU: 'EUR',
  GHA: 'GHS',
  GIB: 'GIP',
  GRC: 'EUR',
  GRL: 'DKK',
  GRD: 'XCD',
  GLP: 'EUR',
  GUM: 'USD',
  GTM: 'GTQ',
  GGY: 'GBP',
  GIN: 'GNF',
  GNB: 'XOF',
  GUY: 'GYD',
  HTI: 'HTG', // ,USD',
  HMD: 'AUD',
  VAT: 'EUR',
  HND: 'HNL',
  HUN: 'HUF',
  ISL: 'ISK',
  IND: 'INR',
  IDN: 'IDR',
  IRN: 'IRR',
  IRQ: 'IQD',
  IRL: 'EUR',
  IMN: 'GBP',
  ISR: 'ILS',
  ITA: 'EUR',
  JAM: 'JMD',
  JPN: 'JPY',
  JEY: 'GBP',
  JOR: 'JOD',
  KAZ: 'KZT',
  KEN: 'KES',
  KIR: 'AUD',
  KWT: 'KWD',
  KGZ: 'KGS',
  LAO: 'LAK',
  LVA: 'EUR',
  LBN: 'LBP',
  LSO: 'LSL', // ,ZAR',
  LBR: 'LRD',
  LBY: 'LYD',
  LIE: 'CHF',
  LTU: 'EUR',
  LUX: 'EUR',
  MDG: 'MGA',
  MWI: 'MWK',
  MYS: 'MYR',
  MDV: 'MVR',
  MLI: 'XOF',
  MLT: 'EUR',
  MHL: 'USD',
  MTQ: 'EUR',
  MRT: 'MRO',
  MUS: 'MUR',
  MYT: 'EUR',
  MEX: 'MXN',
  FSM: 'USD',
  MCO: 'EUR',
  MNG: 'MNT',
  MNE: 'EUR',
  MSR: 'XCD',
  MAR: 'MAD',
  MOZ: 'MZN',
  MMR: 'MMK',
  NAM: 'NAD', // ,ZAR',
  NRU: 'AUD',
  NPL: 'NPR',
  NLD: 'EUR',
  NCL: 'XPF',
  NZL: 'NZD',
  NIC: 'NIO',
  NER: 'XOF',
  NGA: 'NGN',
  NIU: 'NZD',
  NFK: 'AUD',
  MNP: 'USD',
  NOR: 'NOK',
  OMN: 'OMR',
  PAK: 'PKR',
  PLW: 'USD',
  PAN: 'PAB', // ,USD',
  PNG: 'PGK',
  PRY: 'PYG',
  PER: 'PEN',
  PHL: 'PHP',
  PCN: 'NZD',
  POL: 'PLN',
  PRT: 'EUR',
  PRI: 'USD',
  QAT: 'QAR',
  KOR: 'KRW',
  MDA: 'MDL',
  ROU: 'RON',
  RUS: 'RUB',
  RWA: 'RWF',
  REU: 'EUR',
  BLM: 'EUR',
  SHN: 'SHP',
  KNA: 'XCD',
  LCA: 'XCD',
  MAF: 'EUR',
  SPM: 'EUR',
  VCT: 'XCD',
  WSM: 'WST',
  SMR: 'EUR',
  STP: 'STD',
  SAU: 'SAR',
  SEN: 'XOF',
  SRB: 'RSD',
  SYC: 'SCR',
  SLE: 'SLL',
  SGP: 'SGD',
  SXM: 'ANG',
  SVK: 'EUR',
  SVN: 'EUR',
  SLB: 'SBD',
  SOM: 'SOS',
  ZAF: 'ZAR',
  SGS: null,
  SSD: 'SSP',
  ESP: 'EUR',
  LKA: 'LKR',
  PSE: null,
  SDN: 'SDG',
  SUR: 'SRD',
  SJM: 'NOK',
  SWZ: 'SZL',
  SWE: 'SEK',
  CHE: 'CHF',
  SYR: 'SYP',
  TJK: 'TJS',
  THA: 'THB',
  MKD: 'MKD',
  TLS: 'USD',
  TGO: 'XOF',
  TKL: 'NZD',
  TON: 'TOP',
  TTO: 'TTD',
  TUN: 'TND',
  TUR: 'TRY',
  TKM: 'TMT',
  TCA: 'USD',
  TUV: 'AUD',
  UGA: 'UGX',
  UKR: 'UAH',
  ARE: 'AED',
  GBR: 'GBP',
  TZA: 'TZS',
  UMI: 'USD',
  VIR: 'USD',
  USA: 'USD',
  URY: 'UYU',
  UZB: 'UZS',
  VUT: 'VUV',
  VEN: 'VEF',
  VNM: 'VND',
  WLF: 'XPF',
  ESH: 'MAD',
  YEM: 'YER',
  ZMB: 'ZMW',
  ZWE: 'ZWL',
  ALA: 'EUR',
};

// as of Jan 2020

// These are sample phone numbers to populate placeholders for phone inputs. The country data came from https://datahub.io/core/country-codes#data (json format).
// The phone numbers came from libphonenumber-js, https://github.com/catamphetamine/libphonenumber-js a 300kb package we used for NOtHING else.
// Instead of keeping the giant package, we used it to generate a hardcoded set of sample numbers and are including those instead.
// The script that did it is in /scripts/sample-phone-number-generation.
// It relies on a copy of the country data being in the same folder though, so you'll have to download that yourself.
// You will also have to pnpm install libphonenumber-js and remove it after you are done generating the phone numbers.
// These should probably be updated every once in a while. They're not used for anything particularly important, but phone number standards to change from time to time.

// these aren't actually in use, but I don't want to get rid of them in case they come in handy later and they should be tree-shook out of the builds anyway
// eslint-disable-next-line no-unused-vars
const countryCodeToSamplePhoneNumberNatl = {
  TWN: '0912 345 678',
  AFG: '070 123 4567',
  ALB: '067 212 3456',
  DZA: '0551 23 45 67',
  ASM: '(684) 733-1234',
  AND: '312 345',
  AGO: '923 123 456',
  AIA: '(264) 235-1234',
  ATA: '',
  ATG: '(268) 464-1234',
  ARG: '011 15-2345-6789',
  ARM: '077 123456',
  ABW: '560 1234',
  AUS: '0412 345 678',
  AUT: '0664 123456',
  AZE: '040 123 45 67',
  BHS: '(242) 359-1234',
  BHR: '3600 1234',
  BGD: '01812-345678',
  BRB: '(246) 250-1234',
  BLR: '8 029 491-19-11',
  BEL: '0470 12 34 56',
  BLZ: '622-1234',
  BEN: '90 01 12 34',
  BMU: '(441) 370-1234',
  BTN: '17 12 34 56',
  BOL: '71234567',
  BES: '318 1234',
  BIH: '061 123 456',
  BWA: '71 123 456',
  BVT: '',
  BRA: '(11) 96123-4567',
  IOT: '380 1234',
  VGB: '(284) 300-1234',
  BRN: '712 3456',
  BGR: '048 123 456',
  BFA: '70 12 34 56',
  BDI: '79 56 12 34',
  CPV: '991 12 34',
  KHM: '091 234 567',
  CMR: '6 71 23 45 67',
  CAN: '(506) 234-5678',
  CYM: '(345) 323-1234',
  CAF: '70 01 23 45',
  TCD: '63 01 23 45',
  CHL: '(2) 2123 4567',
  CHN: '131 2345 6789',
  HKG: '5123 4567',
  MAC: '6612 3456',
  CXR: '0412 345 678',
  CCK: '0412 345 678',
  COL: '321 1234567',
  COM: '321 23 45',
  COG: '06 123 4567',
  COK: '71 234',
  CRI: '8312 3456',
  HRV: '092 123 4567',
  CUB: '05 1234567',
  CUW: '9 518 1234',
  CYP: '96 123456',
  CZE: '601 123 456',
  CIV: '01 23 45 67',
  PRK: '0192 123 4567',
  COD: '0991 234 567',
  DNK: '32 12 34 56',
  DJI: '77 83 10 01',
  DMA: '(767) 225-1234',
  DOM: '(809) 234-5678',
  ECU: '099 123 4567',
  EGY: '0100 123 4567',
  SLV: '7012 3456',
  GNQ: '222 123 456',
  ERI: '07 123 456',
  EST: '5123 4567',
  ETH: '091 123 4567',
  FLK: '51234',
  FRO: '211234',
  FJI: '701 2345',
  FIN: '041 2345678',
  FRA: '06 12 34 56 78',
  GUF: '0694 20 12 34',
  PYF: '87 12 34 56',
  ATF: '',
  GAB: '06 03 12 34',
  GMB: '301 2345',
  GEO: '555 12 34 56',
  DEU: '01512 3456789',
  GHA: '023 123 4567',
  GIB: '57123456',
  GRC: '691 234 5678',
  GRL: '22 12 34',
  GRD: '(473) 403-1234',
  GLP: '0690 00 12 34',
  GUM: '(671) 300-1234',
  GTM: '5123 4567',
  GGY: '07781 123456',
  GIN: '601 12 34 56',
  GNB: '955 012 345',
  GUY: '609 1234',
  HTI: '34 10 1234',
  HMD: '',
  VAT: '312 345 6789',
  HND: '9123-4567',
  HUN: '06 20 123 4567',
  ISL: '611 1234',
  IND: '081234 56789',
  IDN: '0812-345-678',
  IRN: '0912 345 6789',
  IRQ: '0791 234 5678',
  IRL: '085 012 3456',
  IMN: '07924 123456',
  ISR: '050-234-5678',
  ITA: '312 345 6789',
  JAM: '(876) 210-1234',
  JPN: '090-1234-5678',
  JEY: '07797 712345',
  JOR: '07 9012 3456',
  KAZ: '8 (771) 000 9998',
  KEN: '0712 123456',
  KIR: '72001234',
  KWT: '500 12345',
  KGZ: '0700 123 456',
  LAO: '020 23 123 456',
  LVA: '21 234 567',
  LBN: '71 123 456',
  LSO: '5012 3456',
  LBR: '077 012 3456',
  LBY: '091-2345678',
  LIE: '660 234 567',
  LTU: '(8-612) 34567',
  LUX: '628 123 456',
  MDG: '032 12 345 67',
  MWI: '0991 23 45 67',
  MYS: '012-345 6789',
  MDV: '771-2345',
  MLI: '65 01 23 45',
  MLT: '9696 1234',
  MHL: '235-1234',
  MTQ: '0696 20 12 34',
  MRT: '22 12 34 56',
  MUS: '5251 2345',
  MYT: '0639 01 23 45',
  MEX: '222 123 4567',
  FSM: '350 1234',
  MCO: '06 12 34 56 78',
  MNG: '8812 3456',
  MNE: '067 622 901',
  MSR: '(664) 492-3456',
  MAR: '0650-123456',
  MOZ: '82 123 4567',
  MMR: '09 212 3456',
  NAM: '081 123 4567',
  NRU: '555 1234',
  NPL: '984-1234567',
  NLD: '06 12345678',
  NCL: '75.12.34',
  NZL: '021 123 4567',
  NIC: '8123 4567',
  NER: '93 12 34 56',
  NGA: '0802 123 4567',
  NIU: '888 4012',
  NFK: '3 81234',
  MNP: '(670) 234-5678',
  NOR: '406 12 345',
  OMN: '9212 3456',
  PAK: '0301 2345678',
  PLW: '620 1234',
  PAN: '6123-4567',
  PNG: '7012 3456',
  PRY: '0961 456789',
  PER: '912 345 678',
  PHL: '0905 123 4567',
  PCN: '',
  POL: '512 345 678',
  PRT: '912 345 678',
  PRI: '(787) 234-5678',
  QAT: '3312 3456',
  KOR: '010-2000-0000',
  MDA: '0621 12 345',
  ROU: '0712 034 567',
  RUS: '8 (912) 345-67-89',
  RWA: '0720 123 456',
  REU: '0692 12 34 56',
  BLM: '0690 00 12 34',
  SHN: '51234',
  KNA: '(869) 765-2917',
  LCA: '(758) 284-5678',
  MAF: '0690 00 12 34',
  SPM: '055 12 34',
  VCT: '(784) 430-1234',
  WSM: '72 12345',
  SMR: '66 66 12 12',
  STP: '981 2345',
  // null: '',  // this is Sark https://en.wikipedia.org/wiki/Sark LOL
  SAU: '051 234 5678',
  SEN: '70 123 45 67',
  SRB: '060 1234567',
  SYC: '2 510 123',
  SLE: '(025) 123456',
  SGP: '8123 4567',
  SXM: '(721) 520-5678',
  SVK: '0912 123 456',
  SVN: '031 234 567',
  SLB: '74 21234',
  SOM: '7 1123456',
  ZAF: '071 123 4567',
  SGS: '',
  SSD: '0977 123 456',
  ESP: '612 34 56 78',
  LKA: '071 234 5678',
  PSE: '0599 123 456',
  SDN: '091 123 1234',
  SUR: '741-2345',
  SJM: '412 34 567',
  SWZ: '7612 3456',
  SWE: '070-123 45 67',
  CHE: '078 123 45 67',
  SYR: '0944 567 890',
  TJK: '917 12 3456',
  THA: '081 234 5678',
  MKD: '072 345 678',
  TLS: '7721 2345',
  TGO: '90 11 23 45',
  TKL: '7290',
  TON: '771 5123',
  TTO: '(868) 291-1234',
  TUN: '20 123 456',
  TUR: '0501 234 56 78',
  TKM: '8 66 123456',
  TCA: '(649) 231-1234',
  TUV: '901234',
  UGA: '0712 345678',
  UKR: '050 123 4567',
  ARE: '050 123 4567',
  GBR: '07400 123456',
  TZA: '0621 234 567',
  UMI: '',
  VIR: '(340) 642-1234',
  USA: '(201) 555-0123',
  URY: '094 231 234',
  UZB: '8 91 234 56 78',
  VUT: '591 2345',
  VEN: '0412-1234567',
  VNM: '091 234 56 78',
  WLF: '50 12 34',
  ESH: '0650-123456',
  YEM: '0712 345 678',
  ZMB: '095 5123456',
  ZWE: '071 234 5678',
  ALA: '041 2345678',
};

// these aren't actually in use, but I don't want to get rid of them in case they come in handy later and they should be tree-shook out of the builds anyway
// eslint-disable-next-line no-unused-vars
const countryCodeToSamplePhoneNumberIntl = {
  TWN: '+886 912 345 678',
  AFG: '+93 70 123 4567',
  ALB: '+355 67 212 3456',
  DZA: '+213 551 23 45 67',
  ASM: '+1 684 733 1234',
  AND: '+376 312 345',
  AGO: '+244 923 123 456',
  AIA: '+1 264 235 1234',
  ATA: '',
  ATG: '+1 268 464 1234',
  ARG: '+54 9 11 2345 6789',
  ARM: '+374 77 123456',
  ABW: '+297 560 1234',
  AUS: '+61 412 345 678',
  AUT: '+43 664 123456',
  AZE: '+994 40 123 45 67',
  BHS: '+1 242 359 1234',
  BHR: '+973 3600 1234',
  BGD: '+880 1812 345678',
  BRB: '+1 246 250 1234',
  BLR: '+375 29 491 19 11',
  BEL: '+32 470 12 34 56',
  BLZ: '+501 622 1234',
  BEN: '+229 90 01 12 34',
  BMU: '+1 441 370 1234',
  BTN: '+975 17 12 34 56',
  BOL: '+591 71234567',
  BES: '+599 318 1234',
  BIH: '+387 61 123 456',
  BWA: '+267 71 123 456',
  BVT: '',
  BRA: '+55 11 96123 4567',
  IOT: '+246 380 1234',
  VGB: '+1 284 300 1234',
  BRN: '+673 712 3456',
  BGR: '+359 48 123 456',
  BFA: '+226 70 12 34 56',
  BDI: '+257 79 56 12 34',
  CPV: '+238 991 12 34',
  KHM: '+855 91 234 567',
  CMR: '+237 6 71 23 45 67',
  CAN: '+1 506 234 5678',
  CYM: '+1 345 323 1234',
  CAF: '+236 70 01 23 45',
  TCD: '+235 63 01 23 45',
  CHL: '+56 2 2123 4567',
  CHN: '+86 131 2345 6789',
  HKG: '+852 5123 4567',
  MAC: '+853 6612 3456',
  CXR: '+61 412 345 678',
  CCK: '+61 412 345 678',
  COL: '+57 321 1234567',
  COM: '+269 321 23 45',
  COG: '+242 06 123 4567',
  COK: '+682 71 234',
  CRI: '+506 8312 3456',
  HRV: '+385 92 123 4567',
  CUB: '+53 5 1234567',
  CUW: '+599 9 518 1234',
  CYP: '+357 96 123456',
  CZE: '+420 601 123 456',
  CIV: '+225 01 23 45 67',
  PRK: '+850 192 123 4567',
  COD: '+243 991 234 567',
  DNK: '+45 32 12 34 56',
  DJI: '+253 77 83 10 01',
  DMA: '+1 767 225 1234',
  DOM: '+1 809 234 5678',
  ECU: '+593 99 123 4567',
  EGY: '+20 100 123 4567',
  SLV: '+503 7012 3456',
  GNQ: '+240 222 123 456',
  ERI: '+291 7 123 456',
  EST: '+372 5123 4567',
  ETH: '+251 91 123 4567',
  FLK: '+500 51234',
  FRO: '+298 211234',
  FJI: '+679 701 2345',
  FIN: '+358 41 2345678',
  FRA: '+33 6 12 34 56 78',
  GUF: '+594 694 20 12 34',
  PYF: '+689 87 12 34 56',
  ATF: '',
  GAB: '+241 06 03 12 34',
  GMB: '+220 301 2345',
  GEO: '+995 555 12 34 56',
  DEU: '+49 1512 3456789',
  GHA: '+233 23 123 4567',
  GIB: '+350 57123456',
  GRC: '+30 691 234 5678',
  GRL: '+299 22 12 34',
  GRD: '+1 473 403 1234',
  GLP: '+590 690 00 12 34',
  GUM: '+1 671 300 1234',
  GTM: '+502 5123 4567',
  GGY: '+44 7781 123456',
  GIN: '+224 601 12 34 56',
  GNB: '+245 955 012 345',
  GUY: '+592 609 1234',
  HTI: '+509 34 10 1234',
  HMD: '',
  VAT: '+39 312 345 6789',
  HND: '+504 9123 4567',
  HUN: '+36 20 123 4567',
  ISL: '+354 611 1234',
  IND: '+91 81234 56789',
  IDN: '+62 812 345 678',
  IRN: '+98 912 345 6789',
  IRQ: '+964 791 234 5678',
  IRL: '+353 85 012 3456',
  IMN: '+44 7924 123456',
  ISR: '+972 50 234 5678',
  ITA: '+39 312 345 6789',
  JAM: '+1 876 210 1234',
  JPN: '+81 90 1234 5678',
  JEY: '+44 7797 712345',
  JOR: '+962 7 9012 3456',
  KAZ: '+7 771 000 9998',
  KEN: '+254 712 123456',
  KIR: '+686 72001234',
  KWT: '+965 500 12345',
  KGZ: '+996 700 123 456',
  LAO: '+856 20 23 123 456',
  LVA: '+371 21 234 567',
  LBN: '+961 71 123 456',
  LSO: '+266 5012 3456',
  LBR: '+231 77 012 3456',
  LBY: '+218 91 2345678',
  LIE: '+423 660 234 567',
  LTU: '+370 612 34567',
  LUX: '+352 628 123 456',
  MDG: '+261 32 12 345 67',
  MWI: '+265 991 23 45 67',
  MYS: '+60 12 345 6789',
  MDV: '+960 771 2345',
  MLI: '+223 65 01 23 45',
  MLT: '+356 9696 1234',
  MHL: '+692 235 1234',
  MTQ: '+596 696 20 12 34',
  MRT: '+222 22 12 34 56',
  MUS: '+230 5251 2345',
  MYT: '+262 639 01 23 45',
  MEX: '+52 222 123 4567',
  FSM: '+691 350 1234',
  MCO: '+377 6 12 34 56 78',
  MNG: '+976 8812 3456',
  MNE: '+382 67 622 901',
  MSR: '+1 664 492 3456',
  MAR: '+212 650 123456',
  MOZ: '+258 82 123 4567',
  MMR: '+95 9 212 3456',
  NAM: '+264 81 123 4567',
  NRU: '+674 555 1234',
  NPL: '+977 984 1234567',
  NLD: '+31 6 12345678',
  NCL: '+687 75 12 34',
  NZL: '+64 21 123 4567',
  NIC: '+505 8123 4567',
  NER: '+227 93 12 34 56',
  NGA: '+234 802 123 4567',
  NIU: '+683 888 4012',
  NFK: '+672 3 81234',
  MNP: '+1 670 234 5678',
  NOR: '+47 406 12 345',
  OMN: '+968 9212 3456',
  PAK: '+92 301 2345678',
  PLW: '+680 620 1234',
  PAN: '+507 6123 4567',
  PNG: '+675 7012 3456',
  PRY: '+595 961 456789',
  PER: '+51 912 345 678',
  PHL: '+63 905 123 4567',
  PCN: '',
  POL: '+48 512 345 678',
  PRT: '+351 912 345 678',
  PRI: '+1 787 234 5678',
  QAT: '+974 3312 3456',
  KOR: '+82 10 2000 0000',
  MDA: '+373 621 12 345',
  ROU: '+40 712 034 567',
  RUS: '+7 912 345 67 89',
  RWA: '+250 720 123 456',
  REU: '+262 692 12 34 56',
  BLM: '+590 690 00 12 34',
  SHN: '+290 51234',
  KNA: '+1 869 765 2917',
  LCA: '+1 758 284 5678',
  MAF: '+590 690 00 12 34',
  SPM: '+508 55 12 34',
  VCT: '+1 784 430 1234',
  WSM: '+685 72 12345',
  SMR: '+378 66 66 12 12',
  STP: '+239 981 2345',
  // null: '',  // this is Sark https://en.wikipedia.org/wiki/Sark LOL
  SAU: '+966 51 234 5678',
  SEN: '+221 70 123 45 67',
  SRB: '+381 60 1234567',
  SYC: '+248 2 510 123',
  SLE: '+232 25 123456',
  SGP: '+65 8123 4567',
  SXM: '+1 721 520 5678',
  SVK: '+421 912 123 456',
  SVN: '+386 31 234 567',
  SLB: '+677 74 21234',
  SOM: '+252 7 1123456',
  ZAF: '+27 71 123 4567',
  SGS: '',
  SSD: '+211 977 123 456',
  ESP: '+34 612 34 56 78',
  LKA: '+94 71 234 5678',
  PSE: '+970 599 123 456',
  SDN: '+249 91 123 1234',
  SUR: '+597 741 2345',
  SJM: '+47 412 34 567',
  SWZ: '+268 7612 3456',
  SWE: '+46 70 123 45 67',
  CHE: '+41 78 123 45 67',
  SYR: '+963 944 567 890',
  TJK: '+992 917 12 3456',
  THA: '+66 81 234 5678',
  MKD: '+389 72 345 678',
  TLS: '+670 7721 2345',
  TGO: '+228 90 11 23 45',
  TKL: '+690 7290',
  TON: '+676 771 5123',
  TTO: '+1 868 291 1234',
  TUN: '+216 20 123 456',
  TUR: '+90 501 234 56 78',
  TKM: '+993 66 123456',
  TCA: '+1 649 231 1234',
  TUV: '+688 901234',
  UGA: '+256 712 345678',
  UKR: '+380 50 123 4567',
  ARE: '+971 50 123 4567',
  GBR: '+44 7400 123456',
  TZA: '+255 621 234 567',
  UMI: '',
  VIR: '+1 340 642 1234',
  USA: '+1 201 555 0123',
  URY: '+598 94 231 234',
  UZB: '+998 91 234 56 78',
  VUT: '+678 591 2345',
  VEN: '+58 412 1234567',
  VNM: '+84 91 234 56 78',
  WLF: '+681 50 12 34',
  ESH: '+212 650 123456',
  YEM: '+967 712 345 678',
  ZMB: '+260 95 5123456',
  ZWE: '+263 71 234 5678',
  ALA: '+358 41 2345678',
};

export const countryCodeShortToSamplePhoneNumberNatl = {
  TW: '0912 345 678',
  AF: '070 123 4567',
  AL: '067 212 3456',
  DZ: '0551 23 45 67',
  AS: '(684) 733-1234',
  AD: '312 345',
  AO: '923 123 456',
  AI: '(264) 235-1234',
  AQ: '',
  AG: '(268) 464-1234',
  AR: '011 15-2345-6789',
  AM: '077 123456',
  AW: '560 1234',
  AU: '0412 345 678',
  AT: '0664 123456',
  AZ: '040 123 45 67',
  BS: '(242) 359-1234',
  BH: '3600 1234',
  BD: '01812-345678',
  BB: '(246) 250-1234',
  BY: '8 029 491-19-11',
  BE: '0470 12 34 56',
  BZ: '622-1234',
  BJ: '90 01 12 34',
  BM: '(441) 370-1234',
  BT: '17 12 34 56',
  BO: '71234567',
  BQ: '318 1234',
  BA: '061 123 456',
  BW: '71 123 456',
  BV: '',
  BR: '(11) 96123-4567',
  IO: '380 1234',
  VG: '(284) 300-1234',
  BN: '712 3456',
  BG: '048 123 456',
  BF: '70 12 34 56',
  BI: '79 56 12 34',
  CV: '991 12 34',
  KH: '091 234 567',
  CM: '6 71 23 45 67',
  CA: '(506) 234-5678',
  KY: '(345) 323-1234',
  CF: '70 01 23 45',
  TD: '63 01 23 45',
  CL: '(2) 2123 4567',
  CN: '131 2345 6789',
  HK: '5123 4567',
  MO: '6612 3456',
  CX: '0412 345 678',
  CC: '0412 345 678',
  CO: '321 1234567',
  KM: '321 23 45',
  CG: '06 123 4567',
  CK: '71 234',
  CR: '8312 3456',
  HR: '092 123 4567',
  CU: '05 1234567',
  CW: '9 518 1234',
  CY: '96 123456',
  CZ: '601 123 456',
  CI: '01 23 45 67',
  KP: '0192 123 4567',
  CD: '0991 234 567',
  DK: '32 12 34 56',
  DJ: '77 83 10 01',
  DM: '(767) 225-1234',
  DO: '(809) 234-5678',
  EC: '099 123 4567',
  EG: '0100 123 4567',
  SV: '7012 3456',
  GQ: '222 123 456',
  ER: '07 123 456',
  EE: '5123 4567',
  ET: '091 123 4567',
  FK: '51234',
  FO: '211234',
  FJ: '701 2345',
  FI: '041 2345678',
  FR: '06 12 34 56 78',
  GF: '0694 20 12 34',
  PF: '87 12 34 56',
  TF: '',
  GA: '06 03 12 34',
  GM: '301 2345',
  GE: '555 12 34 56',
  DE: '01512 3456789',
  GH: '023 123 4567',
  GI: '57123456',
  GR: '691 234 5678',
  GL: '22 12 34',
  GD: '(473) 403-1234',
  GP: '0690 00 12 34',
  GU: '(671) 300-1234',
  GT: '5123 4567',
  GG: '07781 123456',
  GN: '601 12 34 56',
  GW: '955 012 345',
  GY: '609 1234',
  HT: '34 10 1234',
  HM: '',
  VA: '312 345 6789',
  HN: '9123-4567',
  HU: '06 20 123 4567',
  IS: '611 1234',
  IN: '081234 56789',
  ID: '0812-345-678',
  IR: '0912 345 6789',
  IQ: '0791 234 5678',
  IE: '085 012 3456',
  IM: '07924 123456',
  IL: '050-234-5678',
  IT: '312 345 6789',
  JM: '(876) 210-1234',
  JP: '090-1234-5678',
  JE: '07797 712345',
  JO: '07 9012 3456',
  KZ: '8 (771) 000 9998',
  KE: '0712 123456',
  KI: '72001234',
  KW: '500 12345',
  KG: '0700 123 456',
  LA: '020 23 123 456',
  LV: '21 234 567',
  LB: '71 123 456',
  LS: '5012 3456',
  LR: '077 012 3456',
  LY: '091-2345678',
  LI: '660 234 567',
  LT: '(8-612) 34567',
  LU: '628 123 456',
  MG: '032 12 345 67',
  MW: '0991 23 45 67',
  MY: '012-345 6789',
  MV: '771-2345',
  ML: '65 01 23 45',
  MT: '9696 1234',
  MH: '235-1234',
  MQ: '0696 20 12 34',
  MR: '22 12 34 56',
  MU: '5251 2345',
  YT: '0639 01 23 45',
  MX: '222 123 4567',
  FM: '350 1234',
  MC: '06 12 34 56 78',
  MN: '8812 3456',
  ME: '067 622 901',
  MS: '(664) 492-3456',
  MA: '0650-123456',
  MZ: '82 123 4567',
  MM: '09 212 3456',
  NA: '081 123 4567',
  NR: '555 1234',
  NP: '984-1234567',
  NL: '06 12345678',
  NC: '75.12.34',
  NZ: '021 123 4567',
  NI: '8123 4567',
  NE: '93 12 34 56',
  NG: '0802 123 4567',
  NU: '888 4012',
  NF: '3 81234',
  MP: '(670) 234-5678',
  NO: '406 12 345',
  OM: '9212 3456',
  PK: '0301 2345678',
  PW: '620 1234',
  PA: '6123-4567',
  PG: '7012 3456',
  PY: '0961 456789',
  PE: '912 345 678',
  PH: '0905 123 4567',
  PN: '',
  PL: '512 345 678',
  PT: '912 345 678',
  PR: '(787) 234-5678',
  QA: '3312 3456',
  KR: '010-2000-0000',
  MD: '0621 12 345',
  RO: '0712 034 567',
  RU: '8 (912) 345-67-89',
  RW: '0720 123 456',
  RE: '0692 12 34 56',
  BL: '0690 00 12 34',
  SH: '51234',
  KN: '(869) 765-2917',
  LC: '(758) 284-5678',
  MF: '0690 00 12 34',
  PM: '055 12 34',
  VC: '(784) 430-1234',
  WS: '72 12345',
  SM: '66 66 12 12',
  ST: '981 2345',
  // null: '',  // this is Sark https://en.wikipedia.org/wiki/Sark LOL
  SA: '051 234 5678',
  SN: '70 123 45 67',
  RS: '060 1234567',
  SC: '2 510 123',
  SL: '(025) 123456',
  SG: '8123 4567',
  SX: '(721) 520-5678',
  SK: '0912 123 456',
  SI: '031 234 567',
  SB: '74 21234',
  SO: '7 1123456',
  ZA: '071 123 4567',
  GS: '',
  SS: '0977 123 456',
  ES: '612 34 56 78',
  LK: '071 234 5678',
  PS: '0599 123 456',
  SD: '091 123 1234',
  SR: '741-2345',
  SJ: '412 34 567',
  SZ: '7612 3456',
  SE: '070-123 45 67',
  CH: '078 123 45 67',
  SY: '0944 567 890',
  TJ: '917 12 3456',
  TH: '081 234 5678',
  MK: '072 345 678',
  TL: '7721 2345',
  TG: '90 11 23 45',
  TK: '7290',
  TO: '771 5123',
  TT: '(868) 291-1234',
  TN: '20 123 456',
  TR: '0501 234 56 78',
  TM: '8 66 123456',
  TC: '(649) 231-1234',
  TV: '901234',
  UG: '0712 345678',
  UA: '050 123 4567',
  AE: '050 123 4567',
  GB: '07400 123456',
  TZ: '0621 234 567',
  UM: '',
  VI: '(340) 642-1234',
  US: '(201) 555-0123',
  UY: '094 231 234',
  UZ: '8 91 234 56 78',
  VU: '591 2345',
  VE: '0412-1234567',
  VN: '091 234 56 78',
  WF: '50 12 34',
  EH: '0650-123456',
  YE: '0712 345 678',
  ZM: '095 5123456',
  ZW: '071 234 5678',
  AX: '041 2345678',
};

// these aren't actually in use, but I don't want to get rid of them in case they come in handy later and they should be tree-shook out of the builds anyway
// eslint-disable-next-line no-unused-vars
const countryCodeShortToSamplePhoneNumberIntl = {
  TW: '+886 912 345 678',
  AF: '+93 70 123 4567',
  AL: '+355 67 212 3456',
  DZ: '+213 551 23 45 67',
  AS: '+1 684 733 1234',
  AD: '+376 312 345',
  AO: '+244 923 123 456',
  AI: '+1 264 235 1234',
  AQ: '',
  AG: '+1 268 464 1234',
  AR: '+54 9 11 2345 6789',
  AM: '+374 77 123456',
  AW: '+297 560 1234',
  AU: '+61 412 345 678',
  AT: '+43 664 123456',
  AZ: '+994 40 123 45 67',
  BS: '+1 242 359 1234',
  BH: '+973 3600 1234',
  BD: '+880 1812 345678',
  BB: '+1 246 250 1234',
  BY: '+375 29 491 19 11',
  BE: '+32 470 12 34 56',
  BZ: '+501 622 1234',
  BJ: '+229 90 01 12 34',
  BM: '+1 441 370 1234',
  BT: '+975 17 12 34 56',
  BO: '+591 71234567',
  BQ: '+599 318 1234',
  BA: '+387 61 123 456',
  BW: '+267 71 123 456',
  BV: '',
  BR: '+55 11 96123 4567',
  IO: '+246 380 1234',
  VG: '+1 284 300 1234',
  BN: '+673 712 3456',
  BG: '+359 48 123 456',
  BF: '+226 70 12 34 56',
  BI: '+257 79 56 12 34',
  CV: '+238 991 12 34',
  KH: '+855 91 234 567',
  CM: '+237 6 71 23 45 67',
  CA: '+1 506 234 5678',
  KY: '+1 345 323 1234',
  CF: '+236 70 01 23 45',
  TD: '+235 63 01 23 45',
  CL: '+56 2 2123 4567',
  CN: '+86 131 2345 6789',
  HK: '+852 5123 4567',
  MO: '+853 6612 3456',
  CX: '+61 412 345 678',
  CC: '+61 412 345 678',
  CO: '+57 321 1234567',
  KM: '+269 321 23 45',
  CG: '+242 06 123 4567',
  CK: '+682 71 234',
  CR: '+506 8312 3456',
  HR: '+385 92 123 4567',
  CU: '+53 5 1234567',
  CW: '+599 9 518 1234',
  CY: '+357 96 123456',
  CZ: '+420 601 123 456',
  CI: '+225 01 23 45 67',
  KP: '+850 192 123 4567',
  CD: '+243 991 234 567',
  DK: '+45 32 12 34 56',
  DJ: '+253 77 83 10 01',
  DM: '+1 767 225 1234',
  DO: '+1 809 234 5678',
  EC: '+593 99 123 4567',
  EG: '+20 100 123 4567',
  SV: '+503 7012 3456',
  GQ: '+240 222 123 456',
  ER: '+291 7 123 456',
  EE: '+372 5123 4567',
  ET: '+251 91 123 4567',
  FK: '+500 51234',
  FO: '+298 211234',
  FJ: '+679 701 2345',
  FI: '+358 41 2345678',
  FR: '+33 6 12 34 56 78',
  GF: '+594 694 20 12 34',
  PF: '+689 87 12 34 56',
  TF: '',
  GA: '+241 06 03 12 34',
  GM: '+220 301 2345',
  GE: '+995 555 12 34 56',
  DE: '+49 1512 3456789',
  GH: '+233 23 123 4567',
  GI: '+350 57123456',
  GR: '+30 691 234 5678',
  GL: '+299 22 12 34',
  GD: '+1 473 403 1234',
  GP: '+590 690 00 12 34',
  GU: '+1 671 300 1234',
  GT: '+502 5123 4567',
  GG: '+44 7781 123456',
  GN: '+224 601 12 34 56',
  GW: '+245 955 012 345',
  GY: '+592 609 1234',
  HT: '+509 34 10 1234',
  HM: '',
  VA: '+39 312 345 6789',
  HN: '+504 9123 4567',
  HU: '+36 20 123 4567',
  IS: '+354 611 1234',
  IN: '+91 81234 56789',
  ID: '+62 812 345 678',
  IR: '+98 912 345 6789',
  IQ: '+964 791 234 5678',
  IE: '+353 85 012 3456',
  IM: '+44 7924 123456',
  IL: '+972 50 234 5678',
  IT: '+39 312 345 6789',
  JM: '+1 876 210 1234',
  JP: '+81 90 1234 5678',
  JE: '+44 7797 712345',
  JO: '+962 7 9012 3456',
  KZ: '+7 771 000 9998',
  KE: '+254 712 123456',
  KI: '+686 72001234',
  KW: '+965 500 12345',
  KG: '+996 700 123 456',
  LA: '+856 20 23 123 456',
  LV: '+371 21 234 567',
  LB: '+961 71 123 456',
  LS: '+266 5012 3456',
  LR: '+231 77 012 3456',
  LY: '+218 91 2345678',
  LI: '+423 660 234 567',
  LT: '+370 612 34567',
  LU: '+352 628 123 456',
  MG: '+261 32 12 345 67',
  MW: '+265 991 23 45 67',
  MY: '+60 12 345 6789',
  MV: '+960 771 2345',
  ML: '+223 65 01 23 45',
  MT: '+356 9696 1234',
  MH: '+692 235 1234',
  MQ: '+596 696 20 12 34',
  MR: '+222 22 12 34 56',
  MU: '+230 5251 2345',
  YT: '+262 639 01 23 45',
  MX: '+52 222 123 4567',
  FM: '+691 350 1234',
  MC: '+377 6 12 34 56 78',
  MN: '+976 8812 3456',
  ME: '+382 67 622 901',
  MS: '+1 664 492 3456',
  MA: '+212 650 123456',
  MZ: '+258 82 123 4567',
  MM: '+95 9 212 3456',
  NA: '+264 81 123 4567',
  NR: '+674 555 1234',
  NP: '+977 984 1234567',
  NL: '+31 6 12345678',
  NC: '+687 75 12 34',
  NZ: '+64 21 123 4567',
  NI: '+505 8123 4567',
  NE: '+227 93 12 34 56',
  NG: '+234 802 123 4567',
  NU: '+683 888 4012',
  NF: '+672 3 81234',
  MP: '+1 670 234 5678',
  NO: '+47 406 12 345',
  OM: '+968 9212 3456',
  PK: '+92 301 2345678',
  PW: '+680 620 1234',
  PA: '+507 6123 4567',
  PG: '+675 7012 3456',
  PY: '+595 961 456789',
  PE: '+51 912 345 678',
  PH: '+63 905 123 4567',
  PN: '',
  PL: '+48 512 345 678',
  PT: '+351 912 345 678',
  PR: '+1 787 234 5678',
  QA: '+974 3312 3456',
  KR: '+82 10 2000 0000',
  MD: '+373 621 12 345',
  RO: '+40 712 034 567',
  RU: '+7 912 345 67 89',
  RW: '+250 720 123 456',
  RE: '+262 692 12 34 56',
  BL: '+590 690 00 12 34',
  SH: '+290 51234',
  KN: '+1 869 765 2917',
  LC: '+1 758 284 5678',
  MF: '+590 690 00 12 34',
  PM: '+508 55 12 34',
  VC: '+1 784 430 1234',
  WS: '+685 72 12345',
  SM: '+378 66 66 12 12',
  ST: '+239 981 2345',
  // null: '', // this is Sark https://en.wikipedia.org/wiki/Sark LOL
  SA: '+966 51 234 5678',
  SN: '+221 70 123 45 67',
  RS: '+381 60 1234567',
  SC: '+248 2 510 123',
  SL: '+232 25 123456',
  SG: '+65 8123 4567',
  SX: '+1 721 520 5678',
  SK: '+421 912 123 456',
  SI: '+386 31 234 567',
  SB: '+677 74 21234',
  SO: '+252 7 1123456',
  ZA: '+27 71 123 4567',
  GS: '',
  SS: '+211 977 123 456',
  ES: '+34 612 34 56 78',
  LK: '+94 71 234 5678',
  PS: '+970 599 123 456',
  SD: '+249 91 123 1234',
  SR: '+597 741 2345',
  SJ: '+47 412 34 567',
  SZ: '+268 7612 3456',
  SE: '+46 70 123 45 67',
  CH: '+41 78 123 45 67',
  SY: '+963 944 567 890',
  TJ: '+992 917 12 3456',
  TH: '+66 81 234 5678',
  MK: '+389 72 345 678',
  TL: '+670 7721 2345',
  TG: '+228 90 11 23 45',
  TK: '+690 7290',
  TO: '+676 771 5123',
  TT: '+1 868 291 1234',
  TN: '+216 20 123 456',
  TR: '+90 501 234 56 78',
  TM: '+993 66 123456',
  TC: '+1 649 231 1234',
  TV: '+688 901234',
  UG: '+256 712 345678',
  UA: '+380 50 123 4567',
  AE: '+971 50 123 4567',
  GB: '+44 7400 123456',
  TZ: '+255 621 234 567',
  UM: '',
  VI: '+1 340 642 1234',
  US: '+1 201 555 0123',
  UY: '+598 94 231 234',
  UZ: '+998 91 234 56 78',
  VU: '+678 591 2345',
  VE: '+58 412 1234567',
  VN: '+84 91 234 56 78',
  WF: '+681 50 12 34',
  EH: '+212 650 123456',
  YE: '+967 712 345 678',
  ZM: '+260 95 5123456',
  ZW: '+263 71 234 5678',
  AX: '+358 41 2345678',
};

export const shortCountryCodeToCountryCode = {
  AE: 'ARE',
  AT: 'AUT',
  AU: 'AUS',
  BE: 'BEL',
  BR: 'BRA',
  CA: 'CAN',
  CH: 'CHE',
  DE: 'DEU',
  DK: 'DNK',
  ES: 'ESP',
  FI: 'FIN',
  FR: 'FRA',
  GB: 'GBR',
  HK: 'HKG',
  ID: 'IDN',
  IE: 'IRL',
  IN: 'IND',
  MY: 'MYS',
  NL: 'NLD',
  NO: 'NOR',
  NZ: 'NZL',
  PH: 'PHL',
  PT: 'PRT',
  SE: 'SWE',
  SG: 'SGP',
  TH: 'THA',
  US: 'USA',
};
